import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  Input,
  NgZone, OnDestroy,
  OnInit,
  QueryList,
  ViewChild
} from '@angular/core';
import {TabComponent} from './tab/component';
import {TabContentComponent} from './tabcontent/component';
import { ViewEncapsulation } from '@angular/core';
import {Tools} from "linkurious-shared";

@Component({
  selector: 'tabs',
  template: `<div class="tabs_wrapper">
  <div #tabArea class="tab_title">
    <button *ngFor="let tab of inputTabs; index as i"
            class="tab__element text--xsmall text--sub_title"
            [class.active]="isActive(i, tab.active)"
            (click)="changeTab(i, tab.click)">
      <ng-container *ngTemplateOutlet="tab.template"></ng-container>
    </button>
  </div>
  <div class="animation">
    <hr #animation>
  </div>
  <div class="tab_content">
    <div *ngFor="let tabContent of contentTabs; index as i"
         class="tab_content_element">
      <ng-template [ngIf]="isActive(i, tabContent.active)">
        <ng-container *ngTemplateOutlet="tabContent.template"></ng-container>
      </ng-template>
    </div>
  </div>
</div>
`,
  styles: [`.tabs_wrapper .tab_title{display:flex;flex-direction:row}.tabs_wrapper .tab_title--center{justify-content:center}.tabs_wrapper .tab__element{flex:1;background:0 0;border:0;padding:5px 25px 15px;border-bottom:1px solid #cbcbcb;color:#363636;justify-content:center;align-items:center;display:inline-flex;line-height:21px;outline:0}.tabs_wrapper .tab__element svg{stroke:#363636!important}.tabs_wrapper .tab__element:focus{outline:0}.tabs_wrapper .tab__element:hover{cursor:pointer;color:#000;transition:.3s ease-in}.tabs_wrapper .tab__element:hover svg{stroke:#000!important;-webkit-transition:.3s ease-in}.tabs_wrapper .animation{position:relative;top:-9px;left:0;margin-bottom:10px}.tabs_wrapper .animation hr{position:absolute;height:3px;border:0;margin-top:7px;background-color:#0081e3}.tabs_wrapper .tab_content_element.none{display:none}`],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabsComponent implements OnInit, AfterViewInit, OnDestroy {

  @ContentChildren(TabComponent) inputTabs: QueryList<TabComponent>;
  @ContentChildren(TabContentComponent) contentTabs: QueryList<TabContentComponent>;

  @Input('tabList') tabList: Array<{icon: string, title: string}>;

  public selectedTab: string;

  private _tabWidth: number;
  private _index: number = 0;
  private _side_margin: number;
  @ViewChild('tabArea')tabArea: ElementRef;
  @ViewChild('animation')animation: ElementRef;

  constructor(private _ngZone: NgZone) {}

  ngOnInit() {
    this._ngZone.runOutsideAngular(() => {
      window.addEventListener('resize', this.resize.bind(this));
    });
  }

  public ngAfterViewInit() {
    this._side_margin = 0;
    this._tabWidth = this.tabArea.nativeElement.firstElementChild.clientWidth;
    this.animation.nativeElement.style.width = this._tabWidth + 'px';
    let tabs = this.tabArea.nativeElement.getElementsByTagName('button');
    let activeTabs = false;
    this.animation.nativeElement.style.transition = 'all 0.3s ease';
    for(let i = 0; i < tabs.length; i++) {
      if ( tabs[i].classList.contains('active') ) {
        this.changeTab(i);
        activeTabs = true;
        break;
      }
    }
    if ( !activeTabs ) {
      this.changeTab(0);
    }
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.resize.bind(this));
  }

  private resize(): void {
    this._tabWidth = this.tabArea.nativeElement.firstElementChild.clientWidth;
    this.animation.nativeElement.style.width = this._tabWidth + 'px';
    this.animation.nativeElement.style.left = ( (this._index * this._tabWidth) + this._side_margin) + 'px';
  }

  public changeTab(index: number, callBack?: EventEmitter<void>): void {
    if ( Tools.isDefined(callBack) ) {
      callBack.emit();
    }
    this._index = index;
    this.selectedTab = 'tab-' + index;
    this.animation.nativeElement.style.left = ( (index * this._tabWidth) + this._side_margin) + 'px';
  }

  public isActive(index: number, forcedValue: boolean): boolean {
    if ( Tools.isDefined(forcedValue) && forcedValue === true ) {
      return this.selectedTab === `tab-${index}`;
    }
    if (index === 0) {
      return this.selectedTab === `tab-${index}` || this.selectedTab === undefined;
    }
    return this.selectedTab === `tab-${index}`;
  }

}
